import { Outlet } from "react-router-dom";
import React from "react";
import { checkLoginTime, clearAllLocalStorage } from "./authUtils";

function PrivateRoutes() {
  const token = localStorage.getItem("access_token");
  const isLoginTimeValid = checkLoginTime();

  if (!token || !isLoginTimeValid) {
    clearAllLocalStorage();
    setTimeout(() => {
      window.location.href = "https://abha.ai/verifyAccount"; // Redirect to the base URL
    }, 100);
    
    return null;
  }

  return <Outlet />;
}

export default PrivateRoutes;
